module.exports = __webpack_public_path__ + "static/media/pre_cast_exc_zon.a235871b.png";